export default "__VITE_ASSET__DYqa2KvP__"